module.exports = __webpack_public_path__ + "static/img/yzz.c5bf297.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/yzz.png
// module id = 6qLl
// module chunks = 1